// extracted by mini-css-extract-plugin
module.exports = {"container":"_2OpWR8kuDeeM761VWdGRfR","card":"_1duSl9XybKOc6a42ZIkpZk","heading":"-S_-U0CVwkIYItIZZwUZd"};